import "core-js/modules/es.array.find.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
export function filterSystemID(value, date) {
  return date.find(function (item) {
    return item.systemId === value;
  }).systemName;
}
export function filterSystemType(val, date) {
  return date.find(function (item) {
    return item.key === val;
  }).value;
}
/**
 * @description Boolean类型数据的过滤器
 * @param {Boolean} value
 * @param {String} trueText 数据为true时转换的文本
 * @param {String} falseText 数据为false时转换的文本
 * @return {String}
 * @author 🦉Owllai🦉 2022/06/09
 */
export function filterBooleanType(value) {
  var trueText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '是';
  var falseText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '否';
  var typeMap = new Map([[true, trueText], [(false, falseText)]]);
  return typeMap.get(value);
}

/**
 * @description Number类型数据的过滤器
 * @param {number} value
 * @return {String}
 * @author 🦉Owllai🦉 2022/06/10
 */
export function filterNumberType(value) {
  var typeMap = new Map([[0, '否'], [1, '是']]);
  return typeMap.get(value);
}

/**
 * @description valid类型数据的过滤器
 * @param {number} value
 * @return {String}
 * @author 🦉Owllai🦉 2022/06/13
 */
export function filterValidType(value) {
  var typeMap = new Map([['VALID', '有效'], ['INVALID', '无效']]);
  return typeMap.get(value);
}

/**
 * @description 条线类型数据的过滤器
 * @param {Array,String} value
 * @param {Array} bizLineList
 * @return {String}
 * @author 🦉Owllai🦉 2022/06/15
 */
export function filterBiz(target, bizLineList) {
  var type = Object.prototype.toString.call(target).slice(8, -1);
  if (type === 'String' && bizLineList.length > 0) {
    return bizLineList.find(function (item) {
      return item.systemId === target;
    }).systemName;
  }
  if (type === 'Array') {
    return bizLineList.filter(function (item) {
      return target.includes(item.systemId);
    }).map(function (item) {
      return item.systemName;
    }).join(',');
  }
}